import { defineMessages } from 'react-intl';

export const scope = 'app.containers.candidates';

export default defineMessages({
  candidate: {
    id: `${scope}.candidates`,
    defaultMessage: 'Candidate',
  },
  exam: {
    id: `${scope}.exam`,
    defaultMessage: 'Exam',
  },
  workflows: {
    id: `${scope}.workflows`,
    defaultMessage: 'Workflows',
  },
  candidates: {
    id: `${scope}.candidates_label`,
    defaultMessage: 'Candidates',
  },
});
